import ColorContrastChecker from 'color-contrast-checker'

import { Badge } from '@tribeplatform/react-ui-kit/Badge'

import { CustomFieldViewProps, getFieldSetting } from '../utils.js'

export const PillsView = ({ value, field }: CustomFieldViewProps) => {
  if (!value?.length) {
    return null
  }
  if (typeof value === 'string') {
    value = [value]
  }

  const contrastChecker = new ColorContrastChecker()

  return (
    <div className="flex flex-wrap space-s-2">
      {value?.map(text => {
        let textColor

        const selectOptions = getFieldSetting(field, 'selectOptions')
        const currentOption = selectOptions?.find(
          option => option?.value === text,
        )
        const color = currentOption?.color
        if (color) {
          textColor =
            contrastChecker.hexToLuminance(color) < 0.5 ? '#ffffff' : '#000000'
        }

        return (
          <Badge
            key={text}
            size="lg"
            style={{ backgroundColor: color, color: textColor }}
          >
            {text}
          </Badge>
        )
      })}
    </div>
  )
}
